import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
} from '@angular/core';
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SharedService } from 'src/app/shared/shared.service';
import { tracking_response_Shipment_model } from '../tracking-item/tracking-item.model';
import { TranslateService } from '@ngx-translate/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
// import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { DialogData } from '../tracking.module';
@Component({
  selector: 'tracking-verify-phone-dialog',
  templateUrl: 'tracking-verify-phone-dialog.html',
  styleUrls: ['tracking-verify-phone-dialog.scss'],
})
export class TrackingVerifyPhone implements AfterViewInit {
  @ViewChild('Text1') text1: ElementRef;
  @ViewChild('numInput1') numInput1: ElementRef;
  @ViewChild('numInput2') numInput2: ElementRef;
  @ViewChild('numInput3') numInput3: ElementRef;
  @ViewChild('numInput4') numInput4: ElementRef;
  @ViewChild('hd1') hd1: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<TrackingVerifyPhone>,
    private _HttpClient: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit(): void {
    //console.log('action => : ' + this.data?.action)
    setTimeout(() => {
      this.numInput1.nativeElement.focus();
    }, 300);
    this.numInput1.nativeElement.style.border = '2px solid #F37021';
  }

  phoneNumber: string;
  validateNumber(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Tab',
    ];
    if (!allowedKeys.includes(event.key) && isNaN(Number(event.key))) {
      event.preventDefault();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  checkAction(
    event: KeyboardEvent,
    currentIndex: number,
    prevIndex: number,
    nextIndex: number
  ) {
    const num1Value = this.numInput1.nativeElement.value;
    const num2Value = this.numInput2.nativeElement.value;
    const num3Value = this.numInput3.nativeElement.value;
    const num4Value = this.numInput4.nativeElement.value;
    let phoneRecheck = num1Value + num2Value + num3Value + num4Value;
    const digitInput = phoneRecheck.length;
    const key = event.key;

    if (currentIndex == 4) {
      if (digitInput == 4) {
        const { con } = this.data.data;
        console.log(' this.data.data', this.data);
        const flag = ['th.kex-express.com', 'th.kerryexpress.com'].includes(
          window.location.hostname
        );
        const url = '/track/api/Shipment/VerifyPhone';
        const api = flag
          ? `https://${window.location.hostname}${url}`
          : `http://10.112.85.112:9001${url}`;
        this._HttpClient
          .post<any>(api, {
            consignmentNo: con,
            verifyCode: phoneRecheck,
          }) 
          .subscribe(
            (res) => {
              if (res.verifySta.code === '01') {
                this.data.isVerify = true;
                let value = { isCheck: true, phone: phoneRecheck, data: res };
                this.dialogRef.close(value);
              } else {
                this.data.isVerify = false;
              }
            },
            (err) => {
              console.error('请求失败：', err);
            }
          );
      } else if (key === 'Backspace') {
        let digit1 = phoneRecheck.substring(0, 1);
        this.numInput1.nativeElement.value = digit1;
        let digit2 = phoneRecheck.substring(1, 2);
        this.numInput2.nativeElement.value = digit2;
        // let digit3 = phoneRecheck.substring(2, 3);
        this.numInput3.nativeElement.value = '';
        this.numInput4.nativeElement.value = '';
        setTimeout(() => {
          this.numInput3.nativeElement.focus();
        });
        this.data.isVerify = true;
        this.numInput4.nativeElement.style.border = '2px solid #777';
      }
    } else if (currentIndex == 3) {
      if (key === 'Backspace') {
        const digit1 = phoneRecheck.substring(0, 1);
        this.numInput1.nativeElement.value = digit1;
        // const digit2 = phoneRecheck.substring(1, 2);
        this.numInput2.nativeElement.value = '';
        this.numInput3.nativeElement.value = '';
        this.numInput4.nativeElement.value = '';
        setTimeout(() => {
          this.numInput2.nativeElement.focus();
        });
        this.data.isVerify = true;
        this.numInput3.nativeElement.style.border = '2px solid #777';
      }
      if (!isNaN(Number(key))) {
        const digit1 = phoneRecheck.substring(0, 1);
        this.numInput1.nativeElement.value = digit1;
        const digit2 = phoneRecheck.substring(1, 2);
        this.numInput2.nativeElement.value = digit2;
        // const digit3 = phoneRecheck.substring(2, 3);
        this.numInput3.nativeElement.value = key;
        this.numInput4.nativeElement.value = '';
        setTimeout(() => {
          this.numInput4.nativeElement.focus();
        });
        this.numInput4.nativeElement.style.border = '2px solid #F37021';
      }
    } else if (currentIndex == 2) {
      if (key === 'Backspace') {
        var digit1 = phoneRecheck.substring(0, 1);
        this.numInput1.nativeElement.value = '';
        this.numInput2.nativeElement.value = '';
        this.numInput3.nativeElement.value = '';
        this.numInput4.nativeElement.value = '';
        setTimeout(() => {
          this.numInput1.nativeElement.focus();
        });
        this.data.isVerify = true;
        this.numInput2.nativeElement.style.border = '2px solid #777';
      }
      if (!isNaN(Number(key))) {
        var digit1 = phoneRecheck.substring(0, 1);
        this.numInput1.nativeElement.value = digit1;
        var digit2 = phoneRecheck.substring(1, 2);
        this.numInput2.nativeElement.value = key;
        this.numInput3.nativeElement.value = '';
        this.numInput4.nativeElement.value = '';
        setTimeout(() => {
          this.numInput3.nativeElement.focus();
        });
        this.numInput3.nativeElement.style.border = '2px solid #F37021';
      }
    } else {
      if (key === 'Backspace') {
        this.numInput1.nativeElement.value = '';
        this.numInput2.nativeElement.value = '';
        this.numInput3.nativeElement.value = '';
        this.numInput4.nativeElement.value = '';
        setTimeout(() => {
          this.numInput1.nativeElement.focus();
        });
        this.data.isVerify = true;
        this.numInput2.nativeElement.style.border = '2px solid #777';
      }
      if (!isNaN(Number(key))) {
        this.numInput1.nativeElement.value = key;
        setTimeout(() => {
          this.numInput2.nativeElement.focus();
        });
        this.numInput2.nativeElement.style.border = '2px solid #F37021';
      }
    }
  }
}
